import * as React from 'react';
import { ComplexImage as ComplexImageComponent } from '../../components/ComplexImage';

interface IComplexImageProps {
  imgUrl?: string | null;
}

export function ComplexImage({ imgUrl }: IComplexImageProps) {
  return <ComplexImageComponent imgUrl={imgUrl || ''} />;
}
